
'use strict';

import './modules/accordion';
import Menu from './modules/humburger';
const menu = new Menu('.humburger_button', '.header_nav', '.humburger_button_txt');
